export enum ErrorTypes {
  Generic = 'ERROR.GENERIC',
  ConfigurationNotFound = 'ERROR.CONFIGURATIONNOTFOUND',
  AxTokenNotFound = 'ERROR.AXTOKENNOTFOUND',
  IframeNotConnected = 'ERROR.IFRAMENOTCONNECTED',
  BackendNotFound = 'ERROR.BACKENDNOTFOUND',
  InvalidAxToken = 'ERROR.INVALIDAXTOKEN',
}
